// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__39ekk","header":"ReportDetails_header__3tPIx","title":"ReportDetails_title__2LRYx","left":"ReportDetails_left__TlvgE"};